import type { HomeCity } from '@/state/types';

/** Quick-start suggestions. Mix of big cities and small towns so players
 *  see that any place in D-A-CH works. */
export const SUGGESTED_CITIES: HomeCity[] = [
  {
    displayName: 'Berlin',
    center: { lat: 52.52, lng: 13.405 },
    country: 'Deutschland',
    state: 'Berlin',
  },
  {
    displayName: 'Hamburg',
    center: { lat: 53.5511, lng: 9.9937 },
    country: 'Deutschland',
    state: 'Hamburg',
  },
  {
    displayName: 'München',
    center: { lat: 48.1351, lng: 11.5820 },
    country: 'Deutschland',
    state: 'Bayern',
  },
  {
    displayName: 'Wien',
    center: { lat: 48.2082, lng: 16.3738 },
    country: 'Österreich',
    state: 'Wien',
  },
  {
    displayName: 'Zürich',
    center: { lat: 47.3769, lng: 8.5417 },
    country: 'Schweiz',
    state: 'Zürich',
  },
  {
    displayName: 'Garmisch-Partenkirchen',
    center: { lat: 47.4917, lng: 11.0958 },
    country: 'Deutschland',
    state: 'Bayern',
  },
];
